import React, { useState, useEffect, useRef } from "react";
import { parseISO, format } from "date-fns";
import * as Yup from "yup";
import { Formik, FieldArray, Form, Field } from "formik";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import SvgIcon from "@material-ui/core/SvgIcon";

const CloseXIcon = (props) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path d="M18 6L6.00081 17.9992M17.9992 18L6 6.00085" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</SvgIcon>
);
import Switch from "@material-ui/core/Switch";
import CustomToggleSwitch from "../CustomToggleSwitch";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Chip from "@material-ui/core/Chip";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { TagsContainer } from "../TagsContainer";
import ChatiaDialogActions from "../ChatiaDialogActions";
// import AsyncSelect from "../AsyncSelect";

const GreenSwitch = withStyles({
	root: {
		width: 36,
		height: 20,
		padding: 0,
		display: 'flex',
	},
	switchBase: {
		padding: 2,
		color: '#fff !important',
		'&:hover': { backgroundColor: 'transparent !important' },
		'&$checked': {
			transform: 'translateX(16px)',
			color: '#fff !important',
			'&:hover': { backgroundColor: 'transparent !important' },
			'& + $track': {
				opacity: '1 !important',
				backgroundColor: '#4caf50 !important',
			},
		},
	},
	thumb: {
		width: 16,
		height: 16,
		boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
		backgroundColor: '#fff !important',
	},
	track: {
		borderRadius: 10,
		opacity: '1 !important',
		backgroundColor: '#9e9e9e !important',
	},
	checked: {},
})(Switch);

const SelectArrowIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginTop: 6, marginRight: 4 }} {...props}>
		<path d="M6 9L12 15L18 9" />
	</svg>
);

const TrashIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" color="currentColor" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" {...props}>
		<path d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5" />
		<path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5" />
		<path d="M9.5 16.5L9.5 10.5" />
		<path d="M14.5 16.5L14.5 10.5" />
	</svg>
);

const AddIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" color="currentColor" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
		<path d="M12 2.00012C17.5228 2.00012 22 6.47727 22 12.0001C22 17.523 17.5228 22.0001 12 22.0001C6.47715 22.0001 2 17.523 2 12.0001M8.909 2.48699C7.9 2.8146 6.96135 3.29828 6.12153 3.90953M3.90943 6.12162C3.29806 6.9616 2.81432 7.90044 2.4867 8.90964" />
		<path d="M12 8.00012V16.0001M16 12.0001L8 12.0001" />
	</svg>
);

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	dialogPaper: {
		borderRadius: "21px 21px 12px 12px !important",
		maxHeight: "85vh !important",
		display: "flex !important",
		flexDirection: "column !important",
		overflow: "hidden !important",
		background: theme.mode === "dark" ? "#121212" : "#ffffff",
		border: "none",
		"& form": {
			display: "flex",
			flexDirection: "column",
			flex: 1,
			minHeight: 0,
			overflow: "hidden",
		},
		"& .MuiDialogContent-root": {
			flex: 1,
			overflowY: "auto !important",
			overflowX: "hidden",
			background: theme.mode === "dark" ? "#121212" : "#ffffff",
			...theme.scrollbarStyles,
		},
		"& .MuiDialogActions-root": {
			flexShrink: 0,
			background: theme.mode === "dark" ? "#121212" : "#ffffff",
		},
		"& .MuiOutlinedInput-root": {
			borderRadius: 12,
		},
		"& .MuiButton-root": {
			borderRadius: 12,
		},
		"& .react-tel-input .form-control": {
			borderRadius: "12px !important",
		},
		"& .MuiSelect-icon": {
			right: 8,
		},
	},
	selectMenu: {
		borderRadius: "12px !important",
		boxShadow: "0 2px 12px rgba(0,0,0,0.08) !important",
		"& .MuiList-root": {
			padding: 4,
			...theme.scrollbarStyles,
		},
		"& .MuiMenuItem-root": {
			borderRadius: 7,
			fontSize: 14,
			"&:hover": {
				backgroundColor: theme.mode === "light" ? "#f5f0eb !important" : "#2a3942 !important",
			},
			"&.Mui-selected": {
				backgroundColor: theme.mode === "light" ? "#ebe5df !important" : "#354a56 !important",
			},
			"&.Mui-selected:hover": {
				backgroundColor: theme.mode === "light" ? "#e0d8d0 !important" : "#3a5060 !important",
			},
		},
	},
	dialogHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: "14px 16px",
		background: theme.palette.primary.main,
		color: theme.palette.primary.contrastText || "#ffffff",
		borderBottom: "none",
		flexShrink: 0,
	},
	dialogHeaderTitle: {
		fontWeight: 600,
		fontSize: 15,
		color: "inherit",
	},
	textField: {
		marginRight: theme.spacing(1),
		flex: 1,
	},
	toggleItem: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: "10px 16px",
		borderRadius: 10,
		border: theme.palette.type === "dark" || theme.mode === "dark"
			? "1px solid rgba(255,255,255,0.10)"
			: "1px solid rgba(0,0,0,0.10)",
		background: theme.palette.type === "dark" || theme.mode === "dark"
			? "rgba(255,255,255,0.02)"
			: "transparent",
		marginTop: 12,
		marginBottom: 4,
		transition: "all 0.2s ease",
		"&:hover": {
			backgroundColor: theme.palette.type === "dark" || theme.mode === "dark"
				? "rgba(255,255,255,0.05)"
				: "#f5f5f5",
			borderColor: theme.palette.type === "dark" || theme.mode === "dark"
				? "rgba(255,255,255,0.20)"
				: "#bdbdbd",
		},
	},
	toggleLabel: {
		fontSize: "0.9rem",
		color: theme.palette.type === "dark" || theme.mode === "dark"
			? "#e9edef"
			: "#424242",
		fontWeight: 500,
	},
	deleteBtn: {
		color: "#e53935",
		padding: 6,
		transition: "all 0.2s ease",
		"&:hover": {
			color: "#c62828 !important",
			backgroundColor: "rgba(229,57,53,0.08) !important",
		},
	},

	extraAttr: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		gap: 6,
	},

	btnWrapper: {
		position: "relative",
	},

	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},

	phoneInput: {
		flex: 1,
		marginLeft: theme.spacing(1),
		marginBottom: theme.spacing(2),
		display: "flex",
		flexDirection: "column",
		"& .react-tel-input .form-control": {
			width: "100%",
			height: "40px",
			fontSize: "16px",
			borderRadius: 12,
			background: theme.mode === "dark" ? "#121212" : "#ffffff",
			color: theme.mode === "dark" ? "#e9edef" : "#111b21",
			border: theme.mode === "dark"
				? "1px solid rgba(255, 255, 255, 0.16)"
				: "1px solid rgba(0, 0, 0, 0.23)",
			"&:hover": {
				borderColor: theme.mode === "dark"
					? "rgba(255, 255, 255, 0.32)"
					: "rgba(0, 0, 0, 0.87)",
			},
			"&:focus": {
				borderColor: theme.palette.primary.main,
				borderWidth: "2px",
			},
		},
		"& .react-tel-input .flag-dropdown": {
			background: theme.mode === "dark" ? "#262626" : "#f5f5f5",
			border: theme.mode === "dark"
				? "1px solid rgba(255, 255, 255, 0.16)"
				: "1px solid rgba(0, 0, 0, 0.23)",
			borderRight: "none",
			borderRadius: "12px 0 0 12px",
			"&.open, &:hover": {
				background: theme.mode === "dark" ? "#2a2a2a" : "#eeeeee",
			},
			"&.open .selected-flag": {
				background: theme.mode === "dark" ? "#2a2a2a" : "#eeeeee",
				borderRadius: "12px 0 0 0",
			},
		},
		"& .react-tel-input .selected-flag .arrow": {
			borderTopColor: theme.mode === "dark" ? "#e9edef" : "#555",
		},
		"& .react-tel-input .selected-flag .arrow.up": {
			borderBottomColor: theme.mode === "dark" ? "#e9edef" : "#555",
		},
		"& .react-tel-input .country-list": {
			position: "fixed !important",
			zIndex: "2000 !important",
			borderRadius: "12px !important",
			boxShadow: theme.mode === "dark"
				? "0 10px 36px rgba(0,0,0,0.45) !important"
				: "0 2px 12px rgba(0,0,0,0.08) !important",
			maxHeight: "250px !important",
			padding: "4px !important",
			background: theme.mode === "dark" ? "#121212" : "#ffffff",
			color: theme.mode === "dark" ? "#e9edef" : "#111b21",
			border: theme.mode === "dark"
				? "1px solid rgba(255,255,255,0.08)"
				: "1px solid rgba(0,0,0,0.06)",
			...theme.scrollbarStyles,
			"& .search": {
				padding: "8px !important",
				background: theme.mode === "dark" ? "#121212" : "#ffffff",
				"& .search-box": {
					borderRadius: "12px !important",
					width: "100% !important",
					padding: "8px 12px !important",
					fontSize: "14px !important",
					background: theme.mode === "dark" ? "#262626" : "#ffffff",
					color: theme.mode === "dark" ? "#e9edef" : "#111b21",
					border: theme.mode === "dark"
						? "1px solid rgba(255,255,255,0.16)"
						: "1px solid rgba(0,0,0,0.16)",
				},
			},
			"& .country": {
				display: "flex !important",
				alignItems: "center !important",
				gap: "8px !important",
				borderRadius: "7px !important",
				padding: "8px 10px !important",
				"&:hover": {
					backgroundColor: (theme.mode === "light" ? "#f5f0eb" : "#2a3942") + " !important",
				},
				"&.highlight": {
					backgroundColor: (theme.mode === "light" ? "#ebe5df" : "#354a56") + " !important",
				},
				"& .flag": {
					position: "relative !important",
					top: "auto !important",
					marginRight: "0 !important",
					flexShrink: 0,
				},
				"& .country-name": {
					marginLeft: "0 !important",
				},
			},
		},
	},

	fieldRow: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1),
		marginTop: theme.spacing(1),
	},

	phoneLabel: {
		fontSize: "0.75rem",
		marginBottom: theme.spacing(0.5),
		display: "block",
	},
	phoneLabelOptional: {
		color: theme.palette.type === "dark" || theme.mode === "dark" ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
	},
}));

const ContactSchema = Yup.object().shape({
	name: Yup.string()
		.min(2, i18n.t("validation.tooShort"))
		.max(250, i18n.t("validation.tooLong"))
		.required(i18n.t("validation.required")),
	number: Yup.string()
		.nullable()
		.transform((value, originalValue) => {
			// Converte string vazia em null para permitir campo opcional
			return originalValue === "" ? null : value;
		})
		.test(
			"is-valid-number",
			"Formato de número inválido (use apenas dígitos, ex: +5511999999999 ou 5511999999999)",
			function(value) {
				// Se for null ou vazio, é válido (campo opcional)
				if (!value) return true;
				// Se tiver valor, valida o formato
				if (value.length < 10) {
					return this.createError({ message: "Número muito curto (mínimo 10 dígitos)" });
				}
				if (value.length > 15) {
					return this.createError({ message: "Número muito longo (máximo 15 dígitos)" });
				}
				if (!/^\+?\d{10,15}$/.test(value)) {
					return this.createError({ message: "Formato de número inválido (use apenas dígitos)" });
				}
				return true;
			}
		),
	email: Yup.string().email(i18n.t("validation.invalidEmail")),
});

const ContactModal = ({ open, onClose, contactId, initialValues, onSave, onSaveSuccess, kanbanLaneSelect }) => {
	const classes = useStyles();
	const isMounted = useRef(true);

	const initialState = {
		name: "",
		number: "",
		email: "",
		followUp: "",
		disableBot: false,
		lgpdAcceptedAt: ""
	};

	const [contact, setContact] = useState(initialState);
	const [disableBot, setDisableBot] = useState(false);
	const [products, setProducts] = useState([]);
	const [newProductName, setNewProductName] = useState("");
	const [newProductStatus, setNewProductStatus] = useState("pending");
	const [editingProductId, setEditingProductId] = useState(null);
	const [editingProductName, setEditingProductName] = useState("");

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	useEffect(() => {
		const fetchContact = async () => {
			if (initialValues) {
				setContact(prevState => {
					return { ...prevState, ...initialValues };
				});
			}

			if (!contactId) return;

			try {
				const { data } = await api.get(`/contacts/${contactId}`);
				if (isMounted.current) {
					setContact(data);
					setDisableBot(data.disableBot);
					setProducts(data.products || []);
				}
			} catch (err) {
				toastError(err);
			}
		};

		fetchContact();
	}, [contactId, open, initialValues]);

	const handleAddProduct = async () => {
		if (!newProductName.trim() || !contactId) return;
		try {
			const { data } = await api.post(`/contacts/${contactId}/products`, {
				name: newProductName.trim(),
				status: newProductStatus,
			});
			setProducts(prev => [...prev, data]);
			setNewProductName("");
			setNewProductStatus("pending");
		} catch (err) {
			toastError(err);
		}
	};

	const handleUpdateProductStatus = async (productId, newStatus) => {
		try {
			await api.put(`/contacts/${contactId}/products/${productId}`, { status: newStatus });
			setProducts(prev => prev.map(p => p.id === productId ? { ...p, status: newStatus } : p));
		} catch (err) {
			toastError(err);
		}
	};

	const handleUpdateProductName = async (productId, newName) => {
		if (!newName.trim()) {
			setEditingProductId(null);
			return;
		}
		try {
			await api.put(`/contacts/${contactId}/products/${productId}`, { name: newName.trim() });
			setProducts(prev => prev.map(p => p.id === productId ? { ...p, name: newName.trim() } : p));
		} catch (err) {
			toastError(err);
		}
		setEditingProductId(null);
	};

	const handleRemoveProduct = async (productId) => {
		try {
			await api.delete(`/contacts/${contactId}/products/${productId}`);
			setProducts(prev => prev.filter(p => p.id !== productId));
		} catch (err) {
			toastError(err);
		}
	};

	const handleClose = () => {
		onClose();
		setProducts([]);
		setNewProductName("");
		setNewProductStatus("pending");
		setContact(initialState);
	};

	const handleSaveContact = async values => {
		try {
			if (contactId) {
				// Edição: não enviar source (mantém o original)
				await api.put(`/contacts/${contactId}`, { ...values, disableBot: disableBot });
				handleClose();
			} else {
				// Criação: adicionar source='manual'
				const { data } = await api.post("/contacts", {
					...values,
					disableBot: disableBot,
					source: 'manual' // NOVO: Marca como contato criado manualmente
				});
				if (onSave) {
					onSave(data);
				}
				handleClose();
			}
			toast.success(i18n.t("contactModal.success"));

			// Chama callback para atualizar a lista
			if (onSaveSuccess) {
				setTimeout(() => {
					onSaveSuccess();
				}, 500);
			}
		} catch (err) {
			toastError(err);
		}
	};

	return (
		<div className={classes.root}>
			<Dialog
				open={open}
				onClose={handleClose}
				maxWidth="lg"
				scroll="paper"
				PaperProps={{
					className: classes.dialogPaper,
				}}
			>
				<div className={classes.dialogHeader}>
					<Typography className={classes.dialogHeaderTitle}>
						{contactId
							? i18n.t("contactModal.title.edit")
							: kanbanLaneSelect
								? i18n.t("contactModal.title.createCard")
								: i18n.t("contactModal.title.add")}
					</Typography>
					<IconButton
						size="small"
						onClick={handleClose}
						style={{
							backgroundColor: "rgba(255, 255, 255, 0.08)",
							color: "#ffffff",
							transition: "all 0.2s ease",
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.18)";
							e.currentTarget.style.color = "#ffffff";
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.08)";
							e.currentTarget.style.color = "#ffffff";
						}}
					>
						<CloseXIcon style={{ fontSize: 18 }} />
					</IconButton>
				</div>
				<Formik
					initialValues={contact}
					enableReinitialize={true}
					validationSchema={ContactSchema}
					onSubmit={(values, actions) => {
						setTimeout(() => {
							handleSaveContact(values);
							actions.setSubmitting(false);
						}, 400);
					}}
				>
					{({ values, errors, touched, isSubmitting, setFieldValue }) => (
						<Form>
							<DialogContent dividers>
								{kanbanLaneSelect && !contactId && (() => {
									const availableLanes = (kanbanLaneSelect.lanes || []).filter(
										(l) => l.id !== "lane0"
									);
									const fallback = availableLanes[0]?.id || "";
									const currentLane =
										kanbanLaneSelect.value &&
										kanbanLaneSelect.value !== "lane0" &&
										availableLanes.some((l) => String(l.id) === String(kanbanLaneSelect.value))
											? kanbanLaneSelect.value
											: fallback;
									if (currentLane && currentLane !== kanbanLaneSelect.value) {
										kanbanLaneSelect.onChange?.(currentLane);
									}
									return (
										<div style={{ marginBottom: 12 }}>
											<TextField
												select
												label={i18n.t("contactModal.form.kanbanLane")}
												value={currentLane || ""}
												onChange={(e) => kanbanLaneSelect.onChange?.(e.target.value)}
												variant="outlined"
												margin="dense"
												fullWidth
												SelectProps={{
													MenuProps: { classes: { paper: classes.selectMenu } },
												}}
												helperText={i18n.t("contactModal.form.kanbanLaneHelp")}
											>
												{availableLanes.map((lane) => (
													<MenuItem key={lane.id} value={lane.id}>
														<span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
															<span
																style={{
																	display: "inline-block",
																	width: 10,
																	height: 10,
																	borderRadius: "50%",
																	background: lane.color || "#9e9e9e",
																}}
															/>
															{lane.name}
														</span>
													</MenuItem>
												))}
											</TextField>
										</div>
									);
								})()}
								<Typography variant="subtitle1" gutterBottom>
									{i18n.t("contactModal.form.mainInfo")}
								</Typography>
								<div className={classes.fieldRow}>
									<div style={{ flex: 1 }}>
										<Field
											as={TextField}
											label={i18n.t("contactModal.form.name")}
											name="name"
											autoFocus
											error={touched.name && Boolean(errors.name)}
											helperText={touched.name && errors.name}
											variant="outlined"
											margin="dense"
											fullWidth
										/>
									</div>
									<div className={classes.phoneInput}>
										<label className={classes.phoneLabel}>
											{i18n.t("contactModal.form.number")} <span className={classes.phoneLabelOptional}>({i18n.t("contactModal.form.optional")})</span>
										</label>
										<PhoneInput
											country={'br'}
											value={values.number}
											onChange={phone => setFieldValue('number', phone)}
											placeholder={i18n.t("validation.phonePlaceholder")}
											inputProps={{
												name: 'number',
												required: false,
											}}
											enableSearch={true}
											searchPlaceholder="Buscar país"
											countryCodeEditable={false}
											specialLabel=""
										/>
										{touched.number && errors.number && (
											<Typography variant="caption" color="error" style={{ marginTop: 4 }}>
												{errors.number}
											</Typography>
										)}
									</div>
								</div>
								<div>
									<Field
										as={TextField}
										label={i18n.t("contactModal.form.email")}
										name="email"
										error={touched.email && Boolean(errors.email)}
										helperText={touched.email && errors.email}
										placeholder={i18n.t("validation.emailPlaceholder")}
										fullWidth
										margin="dense"
										variant="outlined"
									/>
								</div>
								<div>
									<Field
										as={TextField}
										label={i18n.t("contactModal.form.followUp")}
										name="followUp"
										placeholder={i18n.t("contactModal.form.followUpPlaceholder")}
										fullWidth
										margin="dense"
										variant="outlined"
										multiline
										minRows={3}
										inputProps={{
											style: { resize: "vertical" },
										}}
									/>
								</div>
								<div>
									<TagsContainer contact={contact} className={classes.textField} />
								</div>
								{contactId && (
									<div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 10, marginBottom: 4 }}>
										{contact?.whatsapp?.name && (
											<Chip
												size="small"
												label={`Conexão: ${contact.whatsapp.name}`}
												style={{
													borderRadius: 50,
													fontWeight: 500,
													fontSize: "0.8em",
													backgroundColor: "#e3f2fd",
													color: "#1565c0",
												}}
											/>
										)}
										{contact?.tickets?.[0]?.user?.name && (
											<Chip
												size="small"
												label={`Atendente: ${contact.tickets[0].user.name}`}
												style={{
													borderRadius: 50,
													fontWeight: 500,
													fontSize: "0.8em",
													backgroundColor: "#e8f5e9",
													color: "#2e7d32",
												}}
											/>
										)}
										{contact?.wallets?.map(wallet => (
											<Chip
												key={wallet.id}
												size="small"
												label={`Carteira: ${wallet.name}`}
												style={{
													borderRadius: 50,
													fontWeight: 500,
													fontSize: "0.8em",
													backgroundColor: "#f3e5f5",
													color: "#7b1fa2",
												}}
											/>
										))}
									</div>
								)}
								{contactId && (
									<>
										<Typography
											style={{ marginBottom: 8, marginTop: 12 }}
											variant="subtitle1"
										>
											{i18n.t("contactModal.form.products")}
										</Typography>
										{products.map((product) => (
											<div key={product.id} className={classes.extraAttr} style={{ marginBottom: 4 }}>
												{editingProductId === product.id ? (
													<TextField
														value={editingProductName}
														onChange={(e) => setEditingProductName(e.target.value)}
														onBlur={() => handleUpdateProductName(product.id, editingProductName)}
														onKeyDown={(e) => {
															if (e.key === "Enter") handleUpdateProductName(product.id, editingProductName);
															if (e.key === "Escape") setEditingProductId(null);
														}}
														variant="outlined"
														margin="dense"
														size="small"
														autoFocus
														className={classes.textField}
													/>
												) : (
													<TextField
														value={product.name}
														variant="outlined"
														margin="dense"
														size="small"
														className={classes.textField}
														InputProps={{ readOnly: true }}
														onDoubleClick={() => {
															setEditingProductId(product.id);
															setEditingProductName(product.name);
														}}
														style={{ cursor: "pointer" }}
													/>
												)}
												<FormControl variant="outlined" margin="dense" size="small" style={{ minWidth: 150 }}>
													<Select
														value={product.status}
														onChange={(e) => handleUpdateProductStatus(product.id, e.target.value)}
														IconComponent={SelectArrowIcon}
														MenuProps={{
															classes: { paper: classes.selectMenu },
															anchorOrigin: { vertical: "bottom", horizontal: "left" },
															transformOrigin: { vertical: "top", horizontal: "left" },
															getContentAnchorEl: null,
															PaperProps: { style: { marginTop: 5 } },
														}}
													>
														<MenuItem value="pending">{i18n.t("contacts.productStatus.pending")}</MenuItem>
														<MenuItem value="completed">{i18n.t("contacts.productStatus.completed")}</MenuItem>
														<MenuItem value="cancelled">{i18n.t("contacts.productStatus.cancelled")}</MenuItem>
														<MenuItem value="refunded">{i18n.t("contacts.productStatus.refunded")}</MenuItem>
														<MenuItem value="in_progress">{i18n.t("contacts.productStatus.in_progress")}</MenuItem>
													</Select>
												</FormControl>
												<IconButton
													size="small"
													className={classes.deleteBtn}
													onClick={() => handleRemoveProduct(product.id)}
												>
													<TrashIcon />
												</IconButton>
											</div>
										))}
										<div className={classes.extraAttr} style={{ marginTop: 4 }}>
											<TextField
												label={i18n.t("contactModal.form.productName")}
												value={newProductName}
												onChange={(e) => setNewProductName(e.target.value)}
												variant="outlined"
												margin="dense"
												size="small"
												className={classes.textField}
											/>
											<FormControl variant="outlined" margin="dense" size="small" style={{ minWidth: 150 }}>
												<Select
													value={newProductStatus}
													onChange={(e) => setNewProductStatus(e.target.value)}
													IconComponent={SelectArrowIcon}
													MenuProps={{
															classes: { paper: classes.selectMenu },
															anchorOrigin: { vertical: "bottom", horizontal: "left" },
															transformOrigin: { vertical: "top", horizontal: "left" },
															getContentAnchorEl: null,
															PaperProps: { style: { marginTop: 5 } },
														}}
												>
													<MenuItem value="pending">{i18n.t("contacts.productStatus.pending")}</MenuItem>
													<MenuItem value="completed">{i18n.t("contacts.productStatus.completed")}</MenuItem>
													<MenuItem value="cancelled">{i18n.t("contacts.productStatus.cancelled")}</MenuItem>
													<MenuItem value="refunded">{i18n.t("contacts.productStatus.refunded")}</MenuItem>
													<MenuItem value="in_progress">{i18n.t("contacts.productStatus.in_progress")}</MenuItem>
												</Select>
											</FormControl>
											<IconButton
												size="small"
												onClick={handleAddProduct}
												disabled={!newProductName.trim()}
												style={{ alignSelf: "center" }}
											>
												<AddIcon />
											</IconButton>
										</div>
									</>
								)}
								<div className={classes.toggleItem}>
									<span className={classes.toggleLabel}>
										{i18n.t("contactModal.form.chatBotContact")}
									</span>
									<CustomToggleSwitch
										
										
										checked={disableBot}
										onChange={() => setDisableBot(!disableBot)}
										name="disableBot"
									/>
								</div>

								{/* <Typography variant="subtitle1" gutterBottom>{i18n.t("contactModal.form.customer_portfolio")}</Typography> */}
								{/* <div style={{ marginTop: 10 }}>
									<AsyncSelect url="/users" dictKey={"users"}
										initialValue={values.user} width="100%" label={i18n.t("contactModal.form.attendant")}
										onChange={(event, value) => setFieldValue("userId", value ? value.id : null)} />
								</div>
								<div style={{ marginTop: 10 }}>
									<AsyncSelect url="/queue" dictKey={null}
										initialValue={values.queue} width="100%" label={i18n.t("contactModal.form.queue")}
										onChange={(event, value) => setFieldValue("queueId", value ? value.id : null)} />
								</div> */}
								<Typography
									style={{ marginBottom: 8, marginTop: 12 }}
									variant="subtitle1"
								>
									{i18n.t("contactModal.form.extraInfo")}
								</Typography>

								<FieldArray name="extraInfo">
									{({ push, remove }) => (
										<>
											{values.extraInfo &&
												values.extraInfo.length > 0 &&
												values.extraInfo.map((info, index) => (
													<div
														className={classes.extraAttr}
														key={`${index}-info`}
													>
														<Field
															as={TextField}
															label={i18n.t("contactModal.form.extraName")}
															name={`extraInfo[${index}].name`}
															variant="outlined"
															margin="dense"
															className={classes.textField}
														/>
														<Field
															as={TextField}
															label={i18n.t("contactModal.form.extraValue")}
															name={`extraInfo[${index}].value`}
															variant="outlined"
															margin="dense"
															className={classes.textField}
														/>
														<IconButton
															size="small"
															className={classes.deleteBtn}
															onClick={() => remove(index)}
														>
															<TrashIcon />
														</IconButton>
													</div>
												))}
											<div className={classes.extraAttr}>
												<Button
													style={{ flex: 1, marginTop: 8 }}
													variant="outlined"
													color="primary"
													onClick={() => push({ name: "", value: "" })}
												>
													{`+ ${i18n.t("contactModal.buttons.addExtraInfo")}`}
												</Button>
											</div>
										</>
									)}
								</FieldArray>
							</DialogContent>
							<ChatiaDialogActions
								type="submit"
								disabled={isSubmitting}
								loading={isSubmitting}
								saveText={contactId
									? `${i18n.t("contactModal.buttons.okEdit")}`
									: `${i18n.t("contactModal.buttons.okAdd")}`}
							/>
						</Form>
					)}
				</Formik>
			</Dialog>
		</div>
	);
};

export default ContactModal;
